import { z } from 'zod';
import { surrendersSortByValues } from 'src/apis/monolith/mappings';
import {
  ascSortDirectionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { periodTypeValues } from 'src/pages/reporting/auctions/components/period-type';
import { useAuctionLivePageParams } from 'src/pages/transport/network-points/details/point-details/auction-live-table';

const recentAuctionsSchema = z.object({
  periodType: z.enum(periodTypeValues).default('WITHINDAY'),
});

const longTermAuctionsSchema = getPaginationSchema();

const shortTermAuctionsSchema = getPaginationSchema();

const offeredProposalsSchema = getPaginationSchema();

const requestedProposalsSchema = getPaginationSchema();

const surrenderedCapacitySchema = z
  .object({
    sortColumn: z.enum(surrendersSortByValues).default('runtimeStart'),
    sortAscending: ascSortDirectionSchema,
  })
  .merge(getPaginationSchema());

export function useNwpDetailParams() {
  const auctionLive = useAuctionLivePageParams();

  const recentAuctions = usePageParamsFromSchema(recentAuctionsSchema, {
    groupPrefix: 'recentAuctions',
  });

  const longTermAuctions = usePageParamsFromSchema(longTermAuctionsSchema, {
    groupPrefix: 'longTermAuctions',
  });

  const shortTermAuctions = usePageParamsFromSchema(shortTermAuctionsSchema, {
    groupPrefix: 'shortTermAuctions',
  });

  const offeredProposals = usePageParamsFromSchema(offeredProposalsSchema, {
    groupPrefix: 'offeredProposals',
  });

  const requestedProposals = usePageParamsFromSchema(requestedProposalsSchema, {
    groupPrefix: 'requestedProposals',
  });

  const surrenderedCapacity = usePageParamsFromSchema(
    surrenderedCapacitySchema,
    {
      groupPrefix: 'surrenderedCapacity',
    }
  );

  return {
    auctionLive,
    recentAuctions,
    longTermAuctions,
    shortTermAuctions,
    offeredProposals,
    requestedProposals,
    surrenderedCapacity,
  };
}

export type NwpDetailParams = ReturnType<typeof useNwpDetailParams>;
